import React from 'react';

// Adapted from https://blog.logrocket.com/developing-responsive-layouts-with-react-hooks/
// and https://www.pluralsight.com/guides/re-render-react-component-on-window-resize

function debounce(fn, ms) {
    let timer
    return _ => {
      clearTimeout(timer)
      timer = setTimeout(_ => {
        timer = null
        fn.apply(this, arguments)
      }, ms)
    };
}

export default function useViewport() {
    const [width, setWidth] = React.useState(window.innerWidth);
  
    React.useEffect(() => {
        const handleWindowResize = () => debounce(function handleResize() {
            setWidth(window.innerWidth);
          }, 1000);
          
        window.addEventListener("resize", handleWindowResize);
        return () => window.removeEventListener("resize", handleWindowResize);
    }, []);
  
    // Return the width so we can use it in our components
    return { width };
}